import { TLCEvents } from "../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { VirtualShelfControl } from "../controls/VirtualShelfController";
import { AdjustPageHeightControl } from "../controls/adjustPageHeightControl";
import { TooltipControl } from "../controls/tooltipControl";
import { PassThroughManager } from "../managers/PassThroughManager";
import { HeaderView } from "./HeaderView";
import { SearchPageView } from "./SearchPageView";
import { DetailsContainerView } from "./details/DetailsContainerView";

export class MainView {
  constructor() {
    this.id = LS2PAC_CONSTANTS.Ids.mainContent;
    this.init();
  }
  init() {
    new HeaderView(() => {
      this.addEvents();

      AdjustPageHeightControl.adjustMinHeight();
      this.searchPageView = new SearchPageView();

      if (PassThroughManager.init() === false) {
        //if not deep linking...

        // This is old behavior we probably want to ditch anyway
        // but we definitely do not want it to run for new defined routes
        if(window.location.pathname.length <= 1){
          TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onShowLandingPage);
        }
        
      }
    });

    this.detailsContainerView = new DetailsContainerView();
    new VirtualShelfControl();            

    $(window).on("resize", function () {
      TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onWindowResize);
    });
  }
  addEvents() {
    $("#" + this.id).on("click", ".tag", function (event) {
      TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onSearch, {
        searchString: $(event.currentTarget).text(),
        searchType: "tag",
      });
      return false;
    });

    $("body")
      .on(
        "mouseover",
        "." + LS2PAC_CONSTANTS.CssClasses.tooltip,
        function (event) {
          TooltipControl.show(event.currentTarget);
          return false;
        }
      )
      .on(
        "mouseout",
        "." + LS2PAC_CONSTANTS.CssClasses.tooltip,
        function () {
          TooltipControl.hide();
          return false;
        }
      );

    $("#" + LS2PAC_CONSTANTS.Ids.mainPage).on(
      "click",
      "a." + LS2PAC_CONSTANTS.CssClasses.series,
      function (event) {
        //var index = _this.getElementsIndex(event);
        var mainSeries = $(event.currentTarget).attr("data-series");
        //var mainSeries = _this.resources[index].mainSeries;
        TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onSearch, {
          searchString: mainSeries,
          searchType: "seriestitle",
        });
        return false;
      }
    );

    $("#" + LS2PAC_CONSTANTS.Ids.mainPage).on(
      "click",
      ".logout",
      function (event) {
        TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onLogout);
        event.preventDefault();
        return false;
      }
    );

  }

  cleanup(){
    this.detailsContainerView?.cleanup();
    this.searchPageView?.cleanup();
  }
}
